'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DOLPHIN_CHRONO_GAMEPLAY = {
    mcq: 27 * 1000,
    'error-text': 27 * 1000,
    'no-interaction': 20000,
    'picture-spot': 15 * 1000,
    'open-question': 73 * 1000,
    'swiping-cards': 15 * 1000,
    'ordering-cards': 20 * 1000 + 10000,
};
const DOLPHIN_AVERAGE_CHRONO_GAMEPLAY = Object.values(DOLPHIN_CHRONO_GAMEPLAY).reduce((sum, time) => sum + time, 0) /
    Object.keys(DOLPHIN_CHRONO_GAMEPLAY).length;
const getApproximatedSessionTime = (gameTypes) => {
    const time = gameTypes.reduce((sessionTime, gameType) => {
        const gameplayTime = DOLPHIN_CHRONO_GAMEPLAY[gameType];
        return sessionTime + gameplayTime;
    }, 0);
    return time;
};
const getAverageSessionTime = (gameCount) => gameCount * DOLPHIN_AVERAGE_CHRONO_GAMEPLAY;

exports.DOLPHIN_AVERAGE_CHRONO_GAMEPLAY = DOLPHIN_AVERAGE_CHRONO_GAMEPLAY;
exports.getApproximatedSessionTime = getApproximatedSessionTime;
exports.getAverageSessionTime = getAverageSessionTime;
//# sourceMappingURL=get-approximated-session-time.js.map
